import React from 'react';
import { Box, Card, CardHeader, CardContent, Stack, Tabs, Tab } from '@mui/material';

import Scrollbar from '../../../../../components/Scrollbar';
import { SunActiveCategoryForm } from './SunActiveCategoryForm';
import Iconify from '../../../../../components/Iconify';
import { useSelector } from 'react-redux';

export const FullScreenView = props => {
  const { data, submitCallback, handleClose, choices } = props;
  const { module } = useSelector(state => state.app);
  const [currentTab, setCurrentTab] = React.useState(0);

  return (
    <Scrollbar>
      { currentTab === 0
        ? <Box display="flex" flexDirection="row" justifyContent="space-between" mt={1} mr={2}>
          <Stack flex="1 1 70%">
            <Card>
              <CardHeader title={data ? 'Edytuj kategorię' : 'Dodaj kategorię'} sx={{ mt: -1, mb: -2 }} />
              <CardContent>
                <SunActiveCategoryForm
                  data={data}
                  submitCallback={submitCallback}
                  handleClose={handleClose}
                  choices={choices}
                />
              </CardContent>
            </Card>
          </Stack>
        </Box>
        : <Box>asd</Box>}
    </Scrollbar>
  );
};
